"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildLayout = buildLayout;
exports.getAudioPresenterLayers = getAudioPresenterLayers;
exports.getPresenterBanner = getPresenterBanner;
Object.defineProperty(exports, "isBackground", {
  enumerable: true,
  get: function get() {
    return _utils.isBackground;
  }
});
Object.defineProperty(exports, "isOverlay", {
  enumerable: true,
  get: function get() {
    return _utils.isOverlay;
  }
});
exports.sceneBuilder = sceneBuilder;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _underscore = require("underscore");
var _formatBannerMarkup = require("../utils/formatBannerMarkup");
var _constants = require("@studio/constants");
var _utils = require("../utils");
var _sceneLayout = require("../sceneLayout");
var _gridBuilder = _interopRequireDefault(require("../gridBuilder/gridBuilder"));
var _singleBuilder = _interopRequireDefault(require("../singleBuilder/singleBuilder"));
var _featuredBuilder = _interopRequireDefault(require("../featuredBuilder/featuredBuilder"));
var _sideBySideBuilder = _interopRequireDefault(require("../sideBySideBuilder/sideBySideBuilder"));
var _featuredPresenterBuilder = _interopRequireDefault(require("../featuredPresenterBuilder/featuredPresenterBuilder"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @param {Array} sources
 */
function getAudioPresenterLayers(sources) {
  var filterAudioPresenter = sources.filter(function (source) {
    return source && source.type === _constants.AUDIO_PRESENTER;
  });
  return filterAudioPresenter.map(function (source) {
    return {
      source: source,
      layer: {},
      _id: source._id
    };
  });
}

/**
 * @description Get presenter banner template that is live
 * @param  layerSources
 * @returns {{} | undefined}
 */
function getPresenterBanner(layerSources) {
  // Return `undefined` just like `array.find` would
  if (!layerSources.length) return undefined;
  return layerSources.find(function (layer) {
    var _layer$source;
    return (
      // Check if layer is object and not of type `SCENE_LAYER` and is not hidden
      (0, _typeof2["default"])(layer) === 'object' && !(layer !== null && layer !== void 0 && layer.source.hidden) && (layer === null || layer === void 0 || (_layer$source = layer.source) === null || _layer$source === void 0 || (_layer$source = _layer$source.value) === null || _layer$source === void 0 ? void 0 : _layer$source.templateType) === _constants.PRESENTER_BANNER
    );
  });
}

/**
 * @description Apply layers to scene layers,
 * if presenter banner template is live,
 * generate individual presenter banners
 * and render them below each live tile
 * @param {{
 * style : {}
 * layers : []
 * }} mainScene
 * @param  layerSources
 * @param {boolean} isPreview If `true` we can pass presenter banner layer source to scene even if we don't have a live camera source
 * @param {object} fonts Branding fonts
 */
function applyLayerSources() {
  var mainScene = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var layerSources = arguments.length > 1 ? arguments[1] : undefined;
  var isPreview = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var fonts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (layerSources.length) {
    var layers = [];
    layerSources.forEach(function (layerSource) {
      if (layerSource === 'SCENE_LAYER') {
        layers = mainScene.layers ? layers.concat(mainScene.layers) : layers;
        /**
         * For sources like banners, overlays and backgrounds,
         * we still need to check source.hidden property
         */
      } else if ([_constants.MEDIA, _constants.PDF_FILE, _constants.AUDIO_FILE, _constants.VIDEO_FILE, _constants.IMAGE_FILE, _constants.CAMERA_PRESENTER, _constants.SCREEN_PRESENTER].includes(layerSource.source.type) || !layerSource.source.hidden) {
        var source = layerSource.source,
          layer = layerSource.layer,
          id = layerSource._id;
        var value = source.value,
          type = source.type;
        var style = layer.style;
        /**
         * Check if it appears to be a background,
         * if so, merge layer styles with container style,
         * and set the background image to the source value.
         */
        if ((0, _utils.isBackground)(style)) {
          var imageUrl = (0, _typeof2["default"])(value) === 'object' ? value.url : value;
          var backgroundEventDocId = value === null || value === void 0 ? void 0 : value.eventDocId;
          mainScene.style = _objectSpread(_objectSpread({}, style), {}, {
            zIndex: 0,
            backgroundId: id,
            backgroundEventDocId: backgroundEventDocId,
            backgroundImage: "url(".concat(imageUrl, ")")
          });
        } else {
          /**
           * Only handle non-presenter banners since presenter banners
           * will be rendered below individual live video tiles in scene.
           */
          var sourceValue = source.value;
          var isPresenter = (0, _utils.isPresenterBannerLayerSource)(sourceValue);
          var shouldGenerateLayerSource = isPreview || !isPresenter;
          if (shouldGenerateLayerSource) {
            /**
             * This is a normal banner or overlay and should appear on top of everything in scene.
             * Set it to a higher value than possible camera sources that can be in scene.
             */
            if (type === _constants.BANNER || (0, _utils.isOverlay)(style)) {
              var updatedLayer = _objectSpread(_objectSpread({}, layerSource), {}, {
                layer: _objectSpread(_objectSpread({}, layer), {}, {
                  style: _objectSpread(_objectSpread({}, style), {}, {
                    zIndex: 20
                  })
                })
              });
              layers.push(updatedLayer);
            } else {
              layers.push(layerSource);
            }
          }
        }
      }
    });
    var sceneLayers = (mainScene === null || mainScene === void 0 ? void 0 : mainScene.layers) || [];
    var presenterBanner = getPresenterBanner(layerSources);
    if (presenterBanner && (0, _utils.isIterable)(sceneLayers) && sceneLayers.length > 0) {
      (0, _toConsumableArray2["default"])(sceneLayers).map(function (sourceLayer) {
        var source = sourceLayer.source;
        var type = source.type;
        if (type === _constants.CAMERA_PRESENTER) {
          var banner = (0, _utils.buildPresenterBannerLayerSource)(presenterBanner, sourceLayer, mainScene._id, sceneLayers, fonts);
          layers.push(banner);
          return banner;
        }
        return layers;
      });
    } else if (presenterBanner && isPreview) {
      var markup = presenterBanner.source.value.markup;
      markup = (0, _formatBannerMarkup.updateBannerFont)(markup, fonts);
      presenterBanner.source.value.markup = markup;
    }
    mainScene.layers = layers;
  }
  return mainScene;
}

/**
 * @param {{}} layout
 * @param {Array} sources
 * @param  layerSources
 * @param {{}} sourceStyle
 * @param {{}} otherConfig
 * @param {{}} fonts
 * @param {{
 * isPreview : boolean
 * }} otherConfig We can pass custom config inside this object
 * @example We can pass `isPreview` flag when creating a scene preview
 */
function sceneBuilder(layout, sources) {
  var layerSources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var sourceStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var otherConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var fonts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var nonAudioPresenterSources = (0, _utils.getNonAudioPresenterSources)(sources);
  var sortedSources = (0, _utils.moveFeaturedPresenterToFront)(nonAudioPresenterSources);
  var audioSourceIndex = (0, _utils.getAudioSourceIndex)(sortedSources);
  var audioSourceExists = audioSourceIndex > -1;
  var audioSource = null;
  if (audioSourceExists) {
    audioSource = sortedSources.splice(audioSourceIndex, 1)[0];
  }
  var isPreview = otherConfig.isPreview;
  var builtScene = buildLayout(layout, sortedSources, layerSources, sourceStyle, isPreview, fonts);
  if (audioSourceExists && audioSource) {
    var audioLayer = (0, _utils.addAudioSourceToScene)(audioSource);
    builtScene.layers.unshift(audioLayer);
  }
  var audioPresenterLayers = getAudioPresenterLayers(sources);
  if (!(0, _underscore.isEmpty)(audioPresenterLayers)) {
    builtScene.layers = builtScene.layers.concat(audioPresenterLayers);
  }
  return builtScene;
}

/**
 * @param {{}} layout
 * @param {Array} sources
 * @param  layerSources
 * @param {{}} sourceStyle
 * @param {Boolean} isPreview
 * @param {Object} fonts
 */
function buildLayout(layout, sources) {
  var layerSources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var sourceStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var isPreview = arguments.length > 4 ? arguments[4] : undefined;
  var fonts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var mainScene;
  var mergedSourceStyle = _objectSpread(_objectSpread({}, _utils.COMMON_SOURCE_STYLES), sourceStyle);
  if ((0, _sceneLayout.isLayout)(layout, _constants.SINGLE)) {
    /**
     * The reason why this code is necessary is because if overlays are the only sources left when rebuilding a scene it will glitch and make those overlays full screen
     * There is a weird thing going on with overlays when it's passed around layerSources.
     * The overlay positions on the program are unique to overlays and they are stored in the style part of the overlays properties
     * However when it is sent to layerSources it is somehow stored in the title property of overlays
     * We need to investigate why the property gets changed and fix it. When fixed we can then do the code below with isOverlay() function.
     */
    var overlayTitles = new Set(['Upper left', 'Upper right', 'Lower left', 'Lower right', 'Full Screen']);
    var containsOnlyOverlays = layerSources.length >= 2 && layerSources.slice(1).every(function (layerSource) {
      var _layerSource$layer;
      return overlayTitles.has((_layerSource$layer = layerSource.layer) === null || _layerSource$layer === void 0 ? void 0 : _layerSource$layer.title);
    });
    if (!containsOnlyOverlays) {
      mainScene = (0, _singleBuilder["default"])(sources[0], mergedSourceStyle);
    }
  }
  if ((0, _sceneLayout.isLayout)(layout, _constants.SIDE_BY_SIDE)) {
    mainScene = (0, _sideBySideBuilder["default"])(sources, mergedSourceStyle);
  }
  if ((0, _sceneLayout.isLayout)(layout, _constants.GRID)) {
    mainScene = (0, _gridBuilder["default"])(sources, mergedSourceStyle);
  }
  if ((0, _sceneLayout.isLayout)(layout, _constants.FEATURED_PRESENTER)) {
    mainScene = (0, _featuredPresenterBuilder["default"])(sources, mergedSourceStyle);
  }
  if ((0, _sceneLayout.isLayout)(layout, _constants.FEATURED_SCREEN)) {
    mainScene = (0, _featuredBuilder["default"])(sources, _constants.SCREEN_PRESENTER, mergedSourceStyle);
  }
  if ((0, _sceneLayout.isLayout)(layout, _constants.FEATURED_MEDIA)) {
    mainScene = (0, _featuredBuilder["default"])(sources, [_constants.IMAGE_FILE, _constants.PDF_FILE, _constants.VIDEO_FILE, _constants.MEDIA], mergedSourceStyle);
  }

  // TODO: Rename to mainScene.layoutId once we allow this to be sent to API
  if (mainScene) {
    mainScene._id = layout.id;
  }
  return applyLayerSources(mainScene, layerSources, isPreview, fonts);
}